"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var modal_unstyled_1 = __importDefault(require("@prezzee/modal-unstyled"));
var backdrop_1 = __importDefault(require("@prezzee/backdrop"));
var style = __importStar(require("./Modal.style"));
var styled_1 = __importDefault(require("@emotion/styled"));
var ModalBackdrop = (0, styled_1.default)(backdrop_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), style.backdrop);
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog]
 * - [Drawer]
 * - [Menu]
 * - [Popover]
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog] component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
var Modal = (0, react_1.forwardRef)(function (props, ref) {
    var _a = props.BackdropComponent, BackdropComponent = _a === void 0 ? ModalBackdrop : _a, _b = props.closeAfterTransition, closeAfterTransition = _b === void 0 ? false : _b, children = props.children, _c = props.components, components = _c === void 0 ? {} : _c, _d = props.componentsProps, componentsProps = _d === void 0 ? {} : _d, _e = props.disableAutoFocus, disableAutoFocus = _e === void 0 ? false : _e, _f = props.disableEnforceFocus, disableEnforceFocus = _f === void 0 ? false : _f, _g = props.disableEscapeKeyDown, disableEscapeKeyDown = _g === void 0 ? false : _g, _h = props.disablePortal, disablePortal = _h === void 0 ? false : _h, _j = props.disableRestoreFocus, disableRestoreFocus = _j === void 0 ? false : _j, _k = props.disableScrollLock, disableScrollLock = _k === void 0 ? false : _k, _l = props.hideBackdrop, hideBackdrop = _l === void 0 ? false : _l, _m = props.keepMounted, keepMounted = _m === void 0 ? false : _m, other = __rest(props, ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"]);
    var _o = __read((0, react_1.useState)(true), 2), exited = _o[0], setExited = _o[1];
    var commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
    };
    var rootStyle = style.root(true, exited);
    return ((0, jsx_runtime_1.jsx)(modal_unstyled_1.default, __assign({ components: __assign({ Root: 'div' }, components), componentsProps: {
            root: __assign(__assign({}, componentsProps.root), { css: rootStyle }),
        }, BackdropComponent: BackdropComponent, onTransitionEnter: function () { return setExited(false); }, onTransitionExited: function () { return setExited(true); }, ref: ref }, other, commonProps, { children: children })));
});
exports.default = Modal;
var templateObject_1;
//# sourceMappingURL=Modal.js.map